/* VitaVerse 常見問題FAQ 頁面 — 版面重組 2026-09-04
   只做「重新排版」：把頁面內文既有的 .vitaverse-faq DOM 包成 Hero + 左側分類導覽 + 右側問答，
   一個字的文案都不會改寫。沒有這支 JS 時畫面就是頁面內文原本那版（不會壞）。
   搭配 assets/vitaverse-faq-page.css。
   還原：把 layout/theme.liquid 裡載入這兩支檔案那段拿掉即可。 */
(function () {
  'use strict';

  var ICONS = [
    /* 會員與帳號 */ '<circle cx="12" cy="8" r="3.4"/><path d="M4.8 20a7.2 7.2 0 0 1 14.4 0"/>',
    /* 商品保存與食用 */ '<path d="M10 3h4"/><path d="M10.5 3v6.2L5.9 17a2.4 2.4 0 0 0 2 3.7h8.2a2.4 2.4 0 0 0 2-3.7l-4.6-7.8V3"/><path d="M8 14h8"/>',
    /* 付款方式 */ '<rect x="3" y="5.5" width="18" height="13" rx="2.4"/><path d="M3 10h18"/><path d="M6.5 14.5h3"/>',
    /* 訂單、發票與稅務 */ '<path d="M6 3h12v18l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4L6 21z"/><path d="M9 8h6"/><path d="M9 12h6"/>',
    /* 配送與運費 */ '<path d="M3 7h10v9H3z"/><path d="M13 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/>',
    /* 退換貨服務 */ '<path d="M21 12a9 9 0 1 1-2.6-6.4"/><path d="M21 4v5h-5"/>',
    /* 資訊安全 */ '<path d="M12 3l7.5 3v5.4c0 4.6-3.1 8-7.5 9.1-4.4-1.1-7.5-4.5-7.5-9.1V6z"/><path d="M9.2 12.2l2 2 3.6-3.8"/>'
  ];
  var FALLBACK_ICON = '<circle cx="12" cy="12" r="8.6"/><path d="M9.7 9.6a2.4 2.4 0 1 1 3.1 2.9v1.2"/><path d="M12.8 16.9h.01"/>';

  var HERO_ART =
    '<svg viewBox="0 0 232 176" aria-hidden="true" focusable="false">' +
    '<ellipse cx="120" cy="88" rx="86" ry="66" fill="none" stroke="#bfdcf5" stroke-width="1.4" transform="rotate(-14 120 88)"/>' +
    '<rect x="78" y="34" width="94" height="94" rx="20" fill="#ffffff" stroke="#cde3f6" stroke-width="1.6"/>' +
    '<path d="M112 72a13 13 0 1 1 15.6 15.4V95" fill="none" stroke="#2b7fd0" stroke-width="7.5" stroke-linecap="round"/>' +
    '<circle cx="127.6" cy="106" r="4.6" fill="#2b7fd0"/>' +
    '<rect x="150" y="90" width="46" height="46" rx="14" fill="#1a86e0"/>' +
    '<path d="M162 113l7 7 13-14" fill="none" stroke="#ffffff" stroke-width="4.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M203 36l3.1 7.2 7.2 3.1-7.2 3.1-3.1 7.2-3.1-7.2-7.2-3.1 7.2-3.1z" fill="#f4b13f"/>' +
    '</svg>';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function init() {
    var root = document.querySelector('.vitaverse-faq');
    if (!root || root.dataset.vvFaqx) return;

    var groups = [].slice.call(root.querySelectorAll('.faq-group'));
    if (!groups.length) return;
    root.dataset.vvFaqx = '1';
    root.classList.add('vv-faqx');

    var heading = root.querySelector('.faq-page-heading');
    var contact = root.querySelector('.faq-contact');
    var total = root.querySelectorAll('.faq-item').length;

    /* --- Hero --- */
    var hero = el('div', 'vv-hero');
    if (heading) {
      root.insertBefore(hero, heading);
      hero.appendChild(heading);
      var h1 = heading.querySelector('h1');
      if (h1 && h1.textContent.indexOf('FAQ') > -1) {
        var parts = h1.textContent.split('FAQ');
        h1.textContent = '';
        h1.appendChild(document.createTextNode(parts[0].replace(/\s+$/, '')));
        h1.appendChild(el('span', 'vv-h1-en', 'FAQ'));
        if (parts[1]) h1.appendChild(document.createTextNode(parts[1]));
      }
      hero.appendChild(
        el('div', 'vv-hero-meta', groups.length + ' 個分類　·　' + total + ' 個問題')
      );
    } else {
      root.insertBefore(hero, root.firstChild);
    }
    hero.appendChild(el('div', 'vv-hero-art', HERO_ART));

    /* --- 兩欄骨架 --- */
    var layout = el('div', 'vv-layout');
    var side = el('aside', 'vv-side');
    var main = el('div', 'vv-main');
    layout.appendChild(side);
    layout.appendChild(main);
    root.appendChild(layout);

    side.appendChild(el('div', 'vv-side-title', '依主題找答案'));
    side.appendChild(el('div', 'vv-side-sub', '點選分類，快速前往對應問題'));
    var nav = el('nav', 'vv-nav');
    side.appendChild(nav);

    /* --- 工具列 --- */
    var bar = el('div', 'vv-toolbar');
    bar.appendChild(el('span', null, '點選問題查看答案'));
    var toggle = el('button', 'vv-toggle-all');
    toggle.type = 'button';
    bar.appendChild(toggle);
    main.appendChild(bar);

    /* --- 分類區塊 --- */
    var links = [];
    groups.forEach(function (g, i) {
      var h2 = g.querySelector('h2');
      var name = h2 ? h2.textContent.trim() : '分類 ' + (i + 1);
      var items = [].slice.call(g.querySelectorAll('.faq-item'));
      g.id = 'vv-faq-g' + (i + 1);

      var head = el('div', 'vv-ghead');
      var icon = el('span', 'vv-gicon',
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICONS[i] || FALLBACK_ICON) + '</svg>');
      head.appendChild(icon);
      if (h2) head.appendChild(h2);
      head.appendChild(el('span', 'vv-gcount', items.length + ' 個問題'));
      g.insertBefore(head, g.firstChild);

      var list = el('div', 'vv-list');
      items.forEach(function (it) { list.appendChild(it); });
      g.appendChild(list);

      main.appendChild(g);

      var a = el('a', null,
        '<span class="vv-n">' + (i < 9 ? '0' : '') + (i + 1) + '</span>' +
        '<span class="vv-t"></span>' +
        '<span class="vv-c">' + items.length + '</span>');
      a.href = '#' + g.id;
      a.querySelector('.vv-t').textContent = name;
      nav.appendChild(a);
      links.push(a);
    });

    if (contact) {
      contact.id = 'vv-faq-contact';
      main.appendChild(contact);
      var foot = el('div', 'vv-side-foot');
      var ca = el('a', null, '聯絡客服<span>&#8599;</span>');
      ca.href = '#vv-faq-contact';
      foot.appendChild(ca);
      side.appendChild(foot);
    }

    /* --- 預設全部收合（頁面內文裡有些 <details> 帶著 open，只改顯示狀態，不動內容） --- */
    var details = [].slice.call(root.querySelectorAll('.faq-item'));
    details.forEach(function (d) { d.open = false; });

    function syncToggle() {
      var anyOpen = details.some(function (d) { return d.open; });
      toggle.innerHTML = '';
      toggle.appendChild(document.createTextNode(anyOpen ? '收合所有答案' : '展開所有答案'));
      toggle.appendChild(el('i', null, anyOpen ? '&minus;' : '&plus;'));
      toggle.setAttribute('aria-label', anyOpen ? '收合所有答案' : '展開所有答案');
    }
    syncToggle();

    toggle.addEventListener('click', function () {
      var anyOpen = details.some(function (d) { return d.open; });
      details.forEach(function (d) { d.open = !anyOpen; });
      syncToggle();
    });
    root.addEventListener('toggle', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('faq-item')) syncToggle();
    }, true);

    /* --- 分類導覽點擊 --- */
    /* 不自己算座標捲動：這個主題的捲動容器不一定是 window（實測 window.scrollTo /
       scrollIntoView 都推不動），交給瀏覽器原生的錨點跳轉最可靠，
       偏移量由 CSS 的 scroll-margin-top 負責（避開置頂的 header）。 */
    nav.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      setActive(a);
    });

    function setActive(a) {
      links.forEach(function (x) { x.classList.toggle('is-active', x === a); });
    }
    setActive(links[0]);

    /* --- 捲動時同步標示目前分類 --- */
    if ('IntersectionObserver' in window) {
      var seen = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen[en.target.id] = en.isIntersecting ? en.boundingClientRect.top : null; });
        for (var i = 0; i < groups.length; i++) {
          var r = groups[i].getBoundingClientRect();
          if (r.bottom > 140) { setActive(links[i]); break; }
        }
      }, { rootMargin: '-120px 0px -60% 0px', threshold: 0 });
      groups.forEach(function (g) { io.observe(g); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
